/**
 * Registry keys for the EverCycle Buyback card and dialog plugins, which the render info must
 * carry. Kept in a file with no imports, so building render info (row badges, renewal modals,
 * the assessment store) does not pull the plugin components into those pages.
 */
export const EVERCYCLE_BUYBACK_CARD_PLUGIN_NAME = 'EvercycleBuybackCardPluginComponent';
export const EVERCYCLE_BUYBACK_DIALOG_PLUGIN_NAME = 'EvercycleBuybackDialogPluginComponent';
